
(function($) {

$('.c-stat-more').click(function(){
	
	$(this).parent().parent().parent().find('.c-more-stat-info').toggleClass('active');
});

})(jQuery);
